export function formatPhone(phone) {
  return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
}

export function ucfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default {
  formatPhone,
  ucfirst,
};